export default __webpack_public_path__ + "static/media/logo.3b5db8eb.jpg";